<template>
    <svg
        viewBox="0 0 594 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="594"
        height="186">
        <g opacity="0.2">
            <g filter="url(#filter0_i_3064_17043)">
                <path
                    d="M417.779 -167.076C420.239 -201.428 376.146 -218.576 353.569 -192.047L255.861 -77.2407C245.768 -65.3815 229.007 -61.2027 214.367 -66.8961L73.0227 -121.865C40.3967 -134.553 10.0201 -99.1174 28.6168 -70.063L109.643 56.5287C117.938 69.4871 116.764 86.1986 106.732 97.9863L8.56675 213.331C-13.9788 239.822 11.3379 278.871 45.4879 270.279L192.815 233.213C208.16 229.352 224.272 235.618 232.648 248.704L313.062 374.339C331.702 403.461 377.727 392.156 380.184 357.853L390.881 208.492C391.974 193.228 402.974 180.338 418.17 176.515L566.619 139.167C600.69 130.595 603.818 84.5619 571.192 71.8736L429.848 16.9046C415.208 11.2112 406.032 -3.05472 407.132 -18.4114L417.779 -167.076Z"
                    fill="url(#paint0_linear_3064_17043)" />
            </g>
            <path
                d="M353.949 -191.723C376.238 -217.912 419.703 -200.945 417.28 -167.111L406.633 -18.4472C405.517 -2.86559 414.828 11.5999 429.667 17.3706L571.011 72.3396C603.171 84.8468 600.107 130.226 566.497 138.682L418.048 176.03C402.65 179.904 391.491 192.97 390.382 208.457L379.685 357.817C377.264 391.624 331.873 402.8 313.483 374.069L233.069 248.434C224.574 235.163 208.241 228.816 192.693 232.728L45.3659 269.794C11.6472 278.277 -13.2555 239.743 8.94752 213.655L107.113 98.3104C117.286 86.3567 118.478 69.4043 110.065 56.2592L29.0379 -70.3326C10.728 -98.9389 40.6211 -133.93 72.8415 -121.399L214.186 -66.4301C229.021 -60.6605 246.009 -64.8934 256.242 -76.9167L353.949 -191.723Z"
                stroke="white" />
        </g>
        <defs>
            <filter
                id="filter0_i_3064_17043"
                x="0"
                y="-205"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
                width="594"
                height="596">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="9" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3064_17043" />
            </filter>
            <linearGradient
                id="paint0_linear_3064_17043"
                x1="395.063"
                y1="-202.392"
                x2="186.916"
                y2="332.826"
                gradientUnits="userSpaceOnUse">
                <!--suppress RequiredAttributes -->
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>
